module.exports = __webpack_public_path__ + "img/ico_gpx_small.gif";